module.exports = __webpack_public_path__ + "static/media/013.6dc29950.jpg";